<script lang="ts">
	import type { PrimarySectionCard } from '#lib/websites/artists/pages/ArtistDetailPage/utils/transformCataloguePrimaryArtworks/index.js';
	import { ArtworkCard } from '$global/components/ArtworkCard';

	interface Props {
		dataCy: string;
		item: PrimarySectionCard;
	}

	let { dataCy, item: collection }: Props = $props();

	let dataCyPrefix = $derived(`${dataCy}-primary-collection`);
</script>

<ArtworkCard
	dataCy={dataCyPrefix}
	line1={collection.name}
	line2={collection.description}
	variants={{
		line2: 'markdown',
	}}
	class="relative rounded border"
	classes={{
		line2: 'line-clamp-3',
	}}
	href={collection.href}
	image={collection.collection_featured_image}
	alt={collection.name}
/>
